import type { SVGProps } from "react";

/* A single stroke-based icon set so every glyph in the product shares
   weight, join and cap — the kit's icons are all 1.6px rounded strokes. */
const P: Record<string, string> = {
  menu: "M3 6h18M3 12h18M3 18h13",
  search: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14M20 20l-3.6-3.6",
  gift: "M4 11h16v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zM3 7h18v4H3zM12 21V7M12 7S9.5 7 8.3 5.8A2 2 0 0 1 11.2 3C12.4 4.2 12 7 12 7M12 7s2.5 0 3.7-1.2A2 2 0 0 0 12.8 3C11.6 4.2 12 7 12 7",
  bell: "M18 8a6 6 0 1 0-12 0c0 6-2 7-2 7h16s-2-1-2-7M13.7 20a2 2 0 0 1-3.4 0",
  wallet: "M20 8H5a2 2 0 0 1 0-4h13v4M3 6v12a2 2 0 0 0 2 2h15V8H5M17 13h.01",
  chat: "M21 12a8 8 0 0 1-8 8 8.4 8.4 0 0 1-3.6-.8L3 21l1.8-6A8 8 0 1 1 21 12",
  close: "M6 6l12 12M18 6L6 18",
  "chevron-down": "M6 9l6 6 6-6",
  "chevron-up": "M18 15l-6-6-6 6",
  "chevron-left": "M15 18l-6-6 6-6",
  "chevron-right": "M9 18l6-6-6-6",
  "arrow-right": "M5 12h14M13 6l6 6-6 6",
  "arrow-left": "M19 12H5M11 18l-6-6 6-6",
  home: "M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z",
  star: "M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1.1 5.9-5.3-2.9-5.3 2.9 1.1-5.9L3.5 9.7l5.9-.8z",
  history: "M3 5v5h5M3.5 13a8.5 8.5 0 1 0 2-6.4L3 10M12 8v4.5l3 1.7",
  sparkles: "M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6zM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8zM5 15l.6 1.6L7.2 17l-1.6.6L5 19l-.6-1.4L2.8 17l1.6-.4z",
  slots: "M4 6h4v12H4zM10 6h4v12h-4zM16 6h4v12h-4z",
  tv: "M3 7h18v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM8 3l4 4 4-4",
  gamepad: "M7 12h4M9 10v4M15.5 11.5h.01M18 13.5h.01M6.5 7h11a4.5 4.5 0 0 1 4.4 5.4l-.7 3.4A3 3 0 0 1 18.3 18c-1 0-1.8-.5-2.4-1.2l-.6-.8h-6.6l-.6.8c-.6.7-1.4 1.2-2.4 1.2a3 3 0 0 1-2.9-2.2l-.7-3.4A4.5 4.5 0 0 1 6.5 7",
  rocket: "M5 15c-1.5 1.5-1.7 5-1.7 5s3.5-.2 5-1.7c.9-.9.9-2.3 0-3.2a2.2 2.2 0 0 0-3.3 0M12.5 12.5 8 8M20.5 3.5c-4 0-8 2-10.6 6.6L8 14l2 2 3.9-1.9C18.5 11.5 20.5 7.5 20.5 3.5",
  roulette: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8M12 3v5M12 16v5M3 12h5M16 12h5",
  grid: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
  layers: "M12 4 3 8.5l9 4.5 9-4.5zM3 12.5l9 4.5 9-4.5M3 16.5l9 4.5 9-4.5",
  spade: "M12 3s7 5.5 7 10a4 4 0 0 1-7 2.6V19h-1v-3.4A4 4 0 0 1 5 13c0-4.5 7-10 7-10",
  diamond: "M12 3l7 9-7 9-7-9z",
  megaphone: "M4 10v4a1 1 0 0 0 1 1h2l6 4V5L7 9H5a1 1 0 0 0-1 1M17 9a4 4 0 0 1 0 6M6 15v4",
  trophy: "M7 4h10v6a5 5 0 0 1-10 0zM7 6H4v2a3 3 0 0 0 3 3M17 6h3v2a3 3 0 0 1-3 3M9 20h6M12 15v5",
  target: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8M12 11.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1",
  crossed: "M4 4l7 7M20 4l-7 7M4 20l16-16M20 20L4 4",
  book: "M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2zM4 19a2 2 0 0 1 2-2h13",
  chart: "M4 20V10M10 20V4M16 20v-7M22 20H2",
  bank: "M3 10h18L12 4zM5 10v8M9 10v8M15 10v8M19 10v8M3 20h18",
  shield: "M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z",
  "shield-check": "M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6zM9 12l2 2 4-4",
  settings: "M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 7.5 19.4l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.6 1.6 0 0 0 3.6 14H3a2 2 0 1 1 0-4h.1A1.6 1.6 0 0 0 4.6 7.5l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 10 3.6V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 2.5 1.5l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M4 21a8 8 0 0 1 16 0",
  users: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8",
  "user-plus": "M14 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M19 8v6M22 11h-6",
  "user-check": "M14 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M17 11l2 2 4-4",
  "user-x": "M14 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M17 9l5 5M22 9l-5 5",
  copy: "M9 9h10v10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zM5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1",
  edit: "M4 20h4l10-10a2.1 2.1 0 0 0-3-3L5 17zM14 6l3 3",
  external: "M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5",
  qr: "M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2v2h-2zM14 18h2v2h-2zM18 18h2v2h-2z",
  eye: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6",
  "eye-off": "M10.6 6.2A9.6 9.6 0 0 1 12 6c6.5 0 10 6 10 6a17 17 0 0 1-3 3.7M6.6 6.7A17 17 0 0 0 2 12s3.5 6 10 6a9.5 9.5 0 0 0 4-.8M3 3l18 18M9.9 9.9a3 3 0 0 0 4.2 4.2",
  check: "M4 12.5l5 5L20 6.5",
  "check-circle": "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18M8 12l3 3 5-5",
  info: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18M12 11v5M12 8h.01",
  help: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18M9.5 9.5a2.5 2.5 0 1 1 3.4 2.3c-.6.3-.9.8-.9 1.4v.3M12 17h.01",
  lock: "M6 11h12v9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zM8.5 11V7.5a3.5 3.5 0 1 1 7 0V11",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  refresh: "M20 11a8 8 0 1 0-.6 4M20 5v6h-6",
  pause: "M9 5v14M15 5v14",
  play: "M8 5l11 7-11 7z",
  expand: "M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5",
  pip: "M3 5h18v14H3zM12 12h7v5h-7z",
  clock: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18M12 7v5.2l3.2 1.9",
  calendar: "M4 6h16v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zM4 10h16M8 3v4M16 3v4",
  coins: "M9 13a5 3 0 1 0 0-6 5 3 0 0 0 0 6M4 10v4c0 1.7 2.2 3 5 3s5-1.3 5-3v-4M10 17v3c0 1.7 2.2 3 5 3s5-1.3 5-3v-4M10 17c0 1.7 2.2 3 5 3s5-1.3 5-3",
  link: "M9.5 14.5a4 4 0 0 1 0-5.7l2.8-2.8a4 4 0 0 1 5.7 5.7l-1.4 1.4M14.5 9.5a4 4 0 0 1 0 5.7l-2.8 2.8a4 4 0 0 1-5.7-5.7l1.4-1.4",
  fire: "M12 3s1 3-1 5-3 3-3 6a4 4 0 0 0 8 0c0-2-1-3-1-3s3 1 3 4a6 6 0 1 1-12 0C6 9 12 8 12 3",
  send: "M22 3 11 14M22 3l-7 18-4-7-7-4z",
  smile: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18M8.5 14a4.5 4.5 0 0 0 7 0M9 9.5h.01M15 9.5h.01",
  x: "M4 4l7.5 10L4 20h2l6.4-6.4L17 20h3l-8-10.6L19.5 4h-2l-5.6 5.6L8 4z",
  discord: "M8.5 8.5a11 11 0 0 1 7 0M6.5 6.2A16 16 0 0 1 12 5.3a16 16 0 0 1 5.5.9c2 3 2.8 6.4 2.5 10a15 15 0 0 1-4.6 2.3l-1-1.6a10 10 0 0 0 1.6-.8m-8 0a10 10 0 0 0 1.6.8l-1 1.6A15 15 0 0 1 4 16.2c-.3-3.6.5-7 2.5-10M9.5 13.5h.01M14.5 13.5h.01",
  telegram: "M21 4 2.5 11.2l5.4 1.8L19 6.5l-8.6 8.3.3 5 2.6-3.4 4.4 3.2z",
  instagram: "M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4M12 8.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7M17.2 6.8h.01",
  facebook: "M14 21v-8h2.7l.4-3H14V8.2c0-.9.3-1.5 1.6-1.5H17V4c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4.1V10H8v3h2.6v8z",
  youtube: "M21.6 8.2a2.5 2.5 0 0 0-1.8-1.8C18.2 6 12 6 12 6s-6.2 0-7.8.4a2.5 2.5 0 0 0-1.8 1.8A26 26 0 0 0 2 12a26 26 0 0 0 .4 3.8 2.5 2.5 0 0 0 1.8 1.8C5.8 18 12 18 12 18s6.2 0 7.8-.4a2.5 2.5 0 0 0 1.8-1.8A26 26 0 0 0 22 12a26 26 0 0 0-.4-3.8M10 15V9l5 3z",
  image: "M4 5h16v14H4zM4 16l4.5-4.5 3 3L15 11l5 5M9 9.5h.01",
  card: "M3 7h18v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM3 11h18M6.5 15h3",
  bolt: "M13 3 5 14h6l-1 7 8-11h-6z",
  ghost: "M12 3a7 7 0 0 1 7 7v10l-2.3-1.8L14.3 20 12 18.2 9.7 20l-2.4-1.8L5 20V10a7 7 0 0 1 7-7M9.5 10h.01M14.5 10h.01",
  globe: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M3 12h18M12 3a13.5 13.5 0 0 1 3.5 9A13.5 13.5 0 0 1 12 21a13.5 13.5 0 0 1-3.5-9A13.5 13.5 0 0 1 12 3",
  incognito: "M4 12h16M7 7h10l1.5 5h-13zM6.5 14a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5M17.5 14a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5M9.2 16.4a4 4 0 0 1 5.6 0",
  mail: "M4 6h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1M3.5 7.5l8.5 6 8.5-6",
  phone: "M8 3h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1M11 18h2",
  key: "M15 4a5 5 0 1 1 0 10 5 5 0 0 1-1.9-.4L11 15.7H9v2H7v2H4v-2.6l6.4-6.4A5 5 0 0 1 15 4M16.5 7.5h.01",
  monitor: "M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1M8 21h8M12 17v4",
  "id-card": "M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1M9 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4M14 10h4M14 14h3",
  verified: "M12 3l2.3 1.7 2.8-.3 1 2.7 2.4 1.5-1 2.7 1 2.7-2.4 1.5-1 2.7-2.8-.3L12 21l-2.3-1.7-2.8.3-1-2.7L3.5 15.4l1-2.7-1-2.7 2.4-1.5 1-2.7 2.8.3zM9.5 12l2 2 3.5-3.5",
};

export const ICON_NAMES = Object.keys(P).sort();

export type IconName = keyof typeof P | string;

type Props = SVGProps<SVGSVGElement> & { name: IconName; size?: number };

export function Icon({ name, size = 18, strokeWidth = 1.6, ...rest }: Props) {
  const d = P[name];
  if (!d) return null;
  const filled = ["x", "discord", "telegram", "facebook", "youtube"].includes(name);
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={filled ? "currentColor" : "none"}
      stroke={filled ? "none" : "currentColor"}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d={d} />
    </svg>
  );
}
